export const Hero2 = [
    {
        id: 1 ,
        line1: 'Learn a Skill',
        line2: 'Like University’s Do',
        line3: 'For Everyone For Free',
    }
];

export const Welcome2 = [
    {
        id: 1 ,
        title: 'Welcome To The Game',
        line: ".Our Academy won't solve your problems; rather, it will teach you  to do it yourself",
        quote: ".Don't give me a fish teach me how to fish",
    }
];

export const AboutUs2 = [
    {
        id: 1 ,
        firstP: 'We are a non-profit organization established By Tha’er Abu Ghoush in late 2019',
        lastP: `Our main focus towards the youth in the MENA region,
                And we aim to guide the youth towards establishing a
                functional personal system and professional careers
            `,
    }
];

export const Firstquote2 =  `
            Together to build a generation works for a better life
            and have a better future for our region
        `;


export const Services2 = [
    {
        id: 1 ,
        firstP: `
            our academy presenting more then 14 specialty in
            a verious skills such as programming and desgin to
            the up coming metavers and learning the AI and going
            deep in to cyber securty
                `,
        lastP: `
            all of these spicaltys we present in an interactive frame work
            we developed to over come the high drop rate for students
            in the E-Learning World, thats why with us you will find
            a system so strict as university’s are with Theoretical
            and practical exams in the end of each Level
        `,
    }
];

export const Features2 = [
    {
        id: 1 ,
        title: 'Programming Foundation',
        text: ` 
            Lorem Ipsum is simply dummy text of the printing and 
            typesetting industry. Lorem Ipsum has been the industry's
            standard dummy text ever since the 1500s,
        `,
    }
];

export const soon2 = '...Starting Soon';


  
export const Secondquote2 =  `
            Towards a world for our youth excel with their skills
            and hope for more than a job doesn't carry them if they get sick
        `;

export const teamP2 = "Our team is fully depending on volunteers from all around the region experts in the field of our mission and experts supporters Our team starts with two individuals and expands to ten’s within the first year of who shares the vision we adopt, and we are currently have more the 200 active member from the powerful factors that we have that our members are fully commit to achieving our mission unconditionally, and of course our large number reflects the need to meet  our vision and mission and that for sure was a challenge in organizing all of that huge number of tasks in such sensitive topics we provide such as programing and other sort of profission but adapting was the only choice to accomplish our goals, which created a team have a strong immunity to hard times and is more agile with the circumstances and of course, boost their experience and we should mention that we are not  financially supported until now by any organization or individual other than the founders which means a large shortage in resources compared to what we offer all of those challenges made our team like a train, heavy and moving steadily forward and never get out the rails until it reaches. our team is our treasurer and the real hero behind this work";

export const thirdQ2 = "we present this work for each one doors shutted down in their face’s and the didn't lose hope you are the inspiration for us and the reason to continue";
